import React from 'react'
import { generateClassName } from '../../../utils/helpers'

export default function FormContent({className, children}) {
  return (
    <div className={generateClassName(['form-content', className])}>{children}</div>
  )
}
